export default [
  '/',
  '/user/active',
  '/user/active',
  '/reset-password',
  '/no-auth',
  '/study'
]
